<template>
  <v-dialog
    v-model="dialog"
    @keydown.esc="close"
    persistent
    scrollable
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <div class="box-voice m-t-20">
            <p v-html="itemTitle()"></p>
            <div
              class="voice-header m-b-20 d-flex justify-space-between align-center"
            >
              <div class="d-flex align-center width100">
                <span class="m-b-5 m-r-5">beep/</span>
                <v-text-field
                  id="name"
                  v-model="editedItem.path"
                  :disabled="!editedItem.file"
                  label="Filename (server side)"
                  hide-details
                  class="m-b-10"
                ></v-text-field>
              </div>
              <v-icon @click="browserFile">fa-folder-open</v-icon>
              <v-icon
                class="m-l-5"
                @click="playVoice"
                :disabled="!previewVoice"
              >
                {{ isPlaying ? 'fa-stop-circle' : 'fa-play-circle' }}
              </v-icon>
              <input
                ref="file"
                type="file"
                style="display: none"
                accept="audio/wav"
                @change="onFileChange"
              />
            </div>
            <audio ref="myAudio" autoload>
              <source :src="previewVoice" type="audio/wav" />
              Your browser does not support the audio element.
            </audio>
          </div>
        </v-container>
      </v-card-text>

      <div id="error" class="red--text text-center">
        {{ errorMessage }}
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="btn-close" class="btn-secondary" @click="close">
          Cancel
        </v-btn>
        <v-btn id="btn-ok" class="btn-primary" @click="save">
          {{ btnSave }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <audio ref="myAudio" autoload>
      <source :src="previewVoice" type="audio/wav" />
      Your browser does not support the audio element.
    </audio>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogManageAudios',
  props: {
    rules: Object,
    dialog: Boolean,
    editedIndex: Number,
    editedItem: Object,
    errorMessage: String
  },
  data() {
    return {
      fileName: '',
      isPlaying: false,
      previewVoice: ''
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New audio' : 'Edit audio'
    },
    btnSave() {
      return this.editedIndex === -1 ? 'Add' : 'Save'
    }
  },
  created() {
    if (this.editedItem.sign_url) {
      this.previewVoice = sign_url //`${this.minioHost}${this.editedItem.path}`
    }
  },
  mounted() {
    this.$refs.myAudio.addEventListener('play', () => {
      this.isPlaying = true
    })
    this.$refs.myAudio.addEventListener('ended', () => {
      this.isPlaying = false
    })
  },
  methods: {
    browserFile() {
      this.$refs.file.click()
    },

    close() {
      this.$emit('close', null)
    },
    save() {
      this.$emit('save', null)
    },
    onFileChange(e) {
      const files = e.target.files

      if (files[0]) {
        const file = files[0]
        if (file.type === 'audio/wav') {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = e => {
            this.fileName = file.name
            this.previewVoice = e.target.result
            this.editedItem.file = file

            if (this.editedItem.path) {
              const path = this.editedItem.path.split('/').slice(0, -1)
              this.editedItem.path = `${path.join('/')}/${this.fileName}`
            } else {
              this.editedItem.path = this.fileName
            }
          }
        } else {
          e.target.value = ''

          this.fileName = ''
          this.previewVoice = ''
          this.editedItem.file = null
        }
      }
    },
    playVoice() {
      try {
        if (!this.isPlaying) {
          if (this.previewVoice) {
            this.$refs.myAudio.load()

            setTimeout(() => {
              this.$refs.myAudio.play()
            }, 300)
          }
        } else {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      } catch {}
    },
    itemTitle() {
      if (this.editedItem.group) {
        return `${this.editedItem.group}<br><b>${this.editedItem.name}</b>`
      } else if (this.editedItem.name) {
        return `<b>${this.editedItem.name}</b>`
      }

      return
    }
  }
}
</script>
